import React, { useState, useEffect } from "react";
import { Header } from "../header/Header";
import { Sidebar } from "../sidebar/Sidebar";
import { API_URL } from "../../utils/Url";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./dashboard.css";
// ChartJS dependencies register step
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
);

export const Dashboard = () => {
  const [userCounts, setUserCounts] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const getAllUserCounts = async () => {
    try {
      setLoading(true);
      const token = sessionStorage.getItem("token");
      const { data } = await axios.get(`${API_URL}/api/user/get/user/stats`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (data?.success) {
        setUserCounts(data?.data || null);
      }
    } catch (error) {
      console.error("Dashboard Analytics Engine Sync Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAllUserCounts();
  }, []);

  // 🛠️ DYNAMIC CHART DATA COMPILATION LAYER
  // Agar backend ka data abhi load nahi hua, to empty array ya safe fallback data show karega
  const dynamicLabels =
    userCounts?.graphData?.map((item) => {
      // Optional Beauty Format: "2026-05-12" ko short date "12 May" me badalne ke liye
      const dateObj = new Date(item.date);
      return dateObj.toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
      });
    }) || [];

  const dynamicCounts = userCounts?.graphData?.map((item) => item.count) || [];

  const chartData = {
    // Real dynamic dates backend se map ho gayi
    labels: dynamicLabels,
    datasets: [
      {
        fill: true,
        label: "User Registrations",
        // Real count arrays list inject ho gayi
        data: dynamicCounts,
        borderColor: "#4f46e5",
        backgroundColor: "rgba(79, 70, 229, 0.06)",
        tension: 0.38,
        pointBackgroundColor: "#4f46e5",
        pointHoverRadius: 7,
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: { display: false },
      tooltip: {
        backgroundColor: "#1e293b",
        padding: 12,
        titleFont: { size: 14, weight: "bold" },
        bodyFont: { size: 13 },
        cornerRadius: 8,
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { color: "#64748b", font: { size: 11 } },
      },
      y: {
        grid: { color: "#f1f5f9" },
        ticks: {
          color: "#64748b",
          font: { size: 11 },
          beginAtZero: true, // Chart hamesha zero baseline se start hoga
          precision: 0, // Decimal counts decimals hide karne ke liye (.00 users nahi dikhega)
        },
      },
    },
  };

  if (loading) {
    return (
      <div className="text-center py-5">Loading Live Growth Data Matrix...</div>
    );
  }

  return (
    <>
      <Header />
      <Sidebar />

      <div
        className="main-content mt-5 px-3 px-md-4 py-4"
        style={{ backgroundColor: "#f8fafc", minHeight: "100vh" }}
      >
        {/* PREMIUM ENTERPRISE HEADER BLOCK */}
        <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center gap-3 mb-4 p-4 bg-white border rounded-4 shadow-sm position-relative overflow-hidden">
          <div
            className="position-absolute top-0 start-0 h-100 bg-primary"
            style={{ width: "4px" }}
          ></div>
          <div>
            <h2 className="fw-bold text-gray-900 mb-1 fs-3">
              System Metrics Control Panel
            </h2>
            <p className="text-muted small mb-0">
              Real-time application status indices, customer growth streams, and
              platform health.
            </p>
          </div>
          <div className="d-flex align-items-center gap-2 bg-light px-3 py-2 rounded-3 border">
            <span
              className="position-relative d-inline-block me-1"
              style={{ width: "8px", height: "8px" }}
            >
              <span className="position-absolute top-0 start-0 w-100 h-100 bg-success rounded-circle animate-ping opacity-75"></span>
              <span className="position-relative d-inline-block w-100 h-100 bg-success rounded-circle"></span>
            </span>
            <span className="text-secondary fw-semibold small">
              Live Advocate Matrimony Status Connected
            </span>
          </div>
        </div>

        {/* METRICS STACKGRID SYSTEM */}
        <div className="row row-cols-1 row-cols-sm-2 row-cols-xl-4 g-3 mb-4">
          {/* Card 1: Total Platform Footprint */}
          <div className="col">
            <div className="card h-100 border-0 rounded-4 shadow-sm transition-all hover-translate-y bg-white">
              <div className="card-body p-4 d-flex align-items-center gap-3">
                <div
                  className="p-3 bg-primary-subtle text-primary rounded-4 fs-3 d-flex align-items-center justify-content-center"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="bi bi-people-fill"></i>
                </div>
                <div>
                  <div className="text-muted small fw-medium text-uppercase tracking-wider">
                    Total Users
                  </div>
                  <h3 className="fw-extrabold text-dark mb-0 mt-1 fs-3">
                    {loading
                      ? "..."
                      : (userCounts?.total || 0).toLocaleString()}
                  </h3>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2: Verified Live Profiles */}
          <div className="col">
            <div className="card h-100 border-0 rounded-4 shadow-sm transition-all hover-translate-y bg-white">
              <div className="card-body p-4 d-flex align-items-center gap-3">
                <div
                  className="p-3 bg-success-subtle text-success rounded-4 fs-3 d-flex align-items-center justify-content-center"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="bi bi-patch-check-fill"></i>
                </div>
                <div>
                  <div className="text-muted small fw-medium text-uppercase tracking-wider">
                    Approved Profiles
                  </div>
                  <h3 className="fw-extrabold text-dark mb-0 mt-1 fs-3">
                    {loading
                      ? "..."
                      : (userCounts?.approved || 0).toLocaleString()}
                  </h3>
                </div>
              </div>
            </div>
          </div>

          {/* Card 3: Premium Conversion Index */}
          <div className="col">
            <div className="card h-100 border-0 rounded-4 shadow-sm transition-all hover-translate-y bg-white">
              <div className="card-body p-4 d-flex align-items-center gap-3">
                <div
                  className="p-3 bg-warning-subtle text-warning rounded-4 fs-3 d-flex align-items-center justify-content-center"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="bi bi-gem"></i>
                </div>
                <div>
                  <div className="text-muted small fw-medium text-uppercase tracking-wider">
                    Premium Tiers
                  </div>
                  <h3 className="fw-extrabold text-dark mb-0 mt-1 fs-3">
                    {loading
                      ? "..."
                      : (userCounts?.premium || 0).toLocaleString()}
                  </h3>
                </div>
              </div>
            </div>
          </div>

          {/* Card 4: Financial Velocity */}
          <div className="col">
            <div className="card h-100 border-0 rounded-4 shadow-sm transition-all hover-translate-y bg-white">
              <div className="card-body p-4 d-flex align-items-center gap-3">
                <div
                  className="p-3 bg-danger-subtle text-danger rounded-4 fs-3 d-flex align-items-center justify-content-center"
                  style={{ width: "60px", height: "60px" }}
                >
                  <i className="bi bi-graph-up-arrow"></i>
                </div>
                <div>
                  <div className="text-muted small fw-medium text-uppercase tracking-wider">
                    Monthly Revenue
                  </div>
                  <h3 className="fw-extrabold text-dark mb-0 mt-1 fs-3">
                    ₹2.54L
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* SECONDARY EXTRA ANALYSIS MATRIX */}
        <div className="row row-cols-1 row-cols-md-3 g-3 mb-4">
          <div className="col">
            <div className="bg-white p-3 rounded-4 border d-flex align-items-center justify-content-between shadow-xs">
              <span className="text-muted small fw-medium">
                <i className="bi bi-suit-heart-fill text-danger me-2"></i>Total
                Interlocking Matches
              </span>
              <span className="badge bg-light text-dark border font-monospace fw-bold px-2.5 py-1.5 fs-7">
                3,500
              </span>
            </div>
          </div>
          <div className="col">
            <div className="bg-white p-3 rounded-4 border d-flex align-items-center justify-content-between shadow-xs">
              <span className="text-muted small fw-medium">
                <i className="bi bi-clock-history text-warning me-2"></i>
                Awaiting Authentication Queue
              </span>
              <span className="badge bg-warning-subtle text-warning border border-warning-subtle font-monospace fw-bold px-2.5 py-1.5 fs-7">
                {userCounts?.pending || 0}
              </span>
            </div>
          </div>
          <div className="col">
            <div className="bg-white p-3 rounded-4 border d-flex align-items-center justify-content-between shadow-xs">
              <span className="text-muted small fw-medium">
                <i className="bi bi-x-circle-fill text-danger me-2"></i>
                Flagged/Rejected Logs
              </span>
              <span className="badge bg-danger-subtle text-danger border border-danger-subtle font-monospace fw-bold px-2.5 py-1.5 fs-7">
                {userCounts?.rejected || 0}
              </span>
            </div>
          </div>
        </div>

        {/* PRIMARY INFRASTRUCTURE GRID (GRAPH & ACTIVITIES) */}
        <div className="row g-4 mb-4">
          {/* Vector Growth Curve */}
          <div className="col-12 col-xl-8">
            <div className="card border-0 rounded-4 shadow-sm h-100">
              <div className="card-header bg-white border-0 pt-4 px-4 pb-1 d-flex justify-content-between align-items-center">
                <h4 className="fw-bold text-gray-800 fs-5 mb-0">
                  User Growth Ingress
                </h4>
                <span className="badge bg-light text-muted border px-2 py-1 small fw-medium">
                  Live Vector Interpolation
                </span>
              </div>
              <div className="card-body px-4 pb-4 pt-2">
                <div style={{ height: "280px", position: "relative" }}>
                  <Line data={chartData} options={chartOptions} />
                </div>
              </div>
            </div>
          </div>

          {/* Event Stream Log */}
          <div className="col-12 col-xl-4">
            <div className="card border-0 rounded-4 shadow-sm h-100">
              <div className="card-header bg-white border-0 pt-4 px-4 pb-1">
                <h4 className="fw-bold text-gray-800 fs-5 mb-0">
                  System Log Ingress
                </h4>
              </div>
              <div className="card-body px-4 pb-4 pt-2">
                <div className="d-flex flex-column gap-3 overflow-y-auto max-h-300 custom-scrollbar">
                  <div className="d-flex gap-3 p-2.5 rounded-3 hover-bg-light transition-all">
                    <div
                      className="fs-5 text-primary bg-primary-subtle rounded-circle d-flex align-items-center justify-content-center shadow-xs"
                      style={{ width: "38px", height: "38px", flexShrink: 0 }}
                    >
                      <i className="bi bi-person-plus"></i>
                    </div>
                    <div>
                      <div className="text-dark fw-semibold fs-7">
                        Priya Sharma created a profile
                      </div>
                      <div
                        className="text-muted small"
                        style={{ fontSize: "11px" }}
                      >
                        5 mins ago • Account Verification Pending
                      </div>
                    </div>
                  </div>

                  <div className="d-flex gap-3 p-2.5 rounded-3 hover-bg-light transition-all">
                    <div
                      className="fs-5 text-warning bg-warning-subtle rounded-circle d-flex align-items-center justify-content-center shadow-xs"
                      style={{ width: "38px", height: "38px", flexShrink: 0 }}
                    >
                      <i className="bi bi-credit-card-2-front"></i>
                    </div>
                    <div>
                      <div className="text-dark fw-semibold fs-7">
                        Premium Tier Upgrade Completed
                      </div>
                      <div
                        className="text-muted small"
                        style={{ fontSize: "11px" }}
                      >
                        15 mins ago • Rajesh Kumar subscribed to Premium Gold
                      </div>
                    </div>
                  </div>

                  <div className="d-flex gap-3 p-2.5 rounded-3 hover-bg-light transition-all">
                    <div
                      className="fs-5 text-danger bg-danger-subtle rounded-circle d-flex align-items-center justify-content-center shadow-xs"
                      style={{ width: "38px", height: "38px", flexShrink: 0 }}
                    >
                      <i className="bi bi-heart-fill"></i>
                    </div>
                    <div>
                      <div className="text-dark fw-semibold fs-7">
                        Match Request Link Exchanged
                      </div>
                      <div
                        className="text-muted small"
                        style={{ fontSize: "11px" }}
                      >
                        1 hour ago • Vikram Singh linked request bounds
                      </div>
                    </div>
                  </div>

                  <div className="d-flex gap-3 p-2.5 rounded-3 hover-bg-light transition-all">
                    <div
                      className="fs-5 text-success bg-success-subtle rounded-circle d-flex align-items-center justify-content-center shadow-xs"
                      style={{ width: "38px", height: "38px", flexShrink: 0 }}
                    >
                      <i className="bi bi-shield-check"></i>
                    </div>
                    <div>
                      <div className="text-dark fw-semibold fs-7">
                        Profile Identity Verified Success
                      </div>
                      <div
                        className="text-muted small"
                        style={{ fontSize: "11px" }}
                      >
                        2 hours ago • Anita Desai Bar Council ID authorized
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* EXECUTIVE ADMINISTRATIVE INTERACTIVE CONTROLS */}
        <div className="card border-0 rounded-4 shadow-sm mb-2">
          <div className="card-header bg-white border-0 pt-4 px-4 pb-1">
            <h4 className="fw-bold text-gray-800 fs-5 mb-0">
              Executive Quick Vectors
            </h4>
          </div>
          <div className="card-body p-4">
            <div className="row row-cols-2 row-cols-md-4 g-3">
              <div className="col">
                <button
                  onClick={() => navigate("/create/plans")}
                  className="btn btn-outline-light border text-start w-100 p-3 rounded-4 bg-light-subtle shadow-xs hover-shadow transition-all d-flex flex-column gap-2 group"
                >
                  <div
                    className="fs-4 text-primary bg-primary-subtle p-2 rounded-3 d-inline-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <i className="bi bi-plus-circle-fill"></i>
                  </div>
                  <span className="fw-bold text-dark fs-7">Deploy Tiers</span>
                </button>
              </div>
              <div className="col">
                <button
                  onClick={() => navigate("/all/users/plan")}
                  className="btn btn-outline-light border text-start w-100 p-3 rounded-4 bg-light-subtle shadow-xs hover-shadow transition-all d-flex flex-column gap-2"
                >
                  <div
                    className="fs-4 text-success bg-success-subtle p-2 rounded-3 d-inline-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <i className="bi bi-person-check-fill"></i>
                  </div>
                  <span className="fw-bold text-dark fs-7">
                    Review Profiles
                  </span>
                </button>
              </div>
              <div className="col">
                <button
                  onClick={() => navigate("/queries")}
                  className="btn btn-outline-light border text-start w-100 p-3 rounded-4 bg-light-subtle shadow-xs hover-shadow transition-all d-flex flex-column gap-2"
                >
                  <div
                    className="fs-4 text-warning bg-warning-subtle p-2 rounded-3 d-inline-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <i className="bi bi-chat-square-dots-fill"></i>
                  </div>
                  <span className="fw-bold text-dark fs-7">User Helpdesk</span>
                </button>
              </div>
              <div className="col">
                <button className="btn btn-outline-light border text-start w-100 p-3 rounded-4 bg-light-subtle shadow-xs hover-shadow transition-all d-flex flex-column gap-2">
                  <div
                    className="fs-4 text-danger bg-danger-subtle p-2 rounded-3 d-inline-flex align-items-center justify-content-center"
                    style={{ width: "40px", height: "40px" }}
                  >
                    <i className="bi bi-file-earmark-bar-graph-fill"></i>
                  </div>
                  <span className="fw-bold text-dark fs-7">System Reports</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
